import { Accordion } from '@/components/ui/accordion'
import FcaTimelineItem from '@/components/claim-updates/FcaTimelineItem'

const FcaTimeline = ({ items }) => {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map(item => (
        <FcaTimelineItem key={item.id} item={item} />
      ))}
    </Accordion>
  )
}

export default FcaTimeline
